export default [
  { name: 'Question', prop: 'question_id', type: 'autocomplete', references: 'admin/questions', referenceProp: 'question' },
  { name: 'Timer Type', prop: 'timer_type', type: 'text' }
]
